import { ComponentProps } from "react";
import { CachedStateProvider, IControlledMutator } from "sonobello.utilities.react";

import { LocalStorageConfigs } from "../../types/LocalStorage";
import AppContextValueProvider from "../../App/Compositions/AppContextValueProvider";
import CalendarController, {
  ICalendarControllerProps,
  ICalendarPrerequisitesRecord
} from "../Components/CalendarController";
import { Step } from "../../types/Step";

const defaultCalendarPrerequisiteSteps: ICalendarControllerProps["calendarPrerequisiteSteps"] = [
  Step.scheduling,
  Step.medicalGeneral,
  Step.medicalAll
];

/** A {@link CalendarController} which reads and writes its control to the cache. */
const CachedCalendarController: React.FC<
  Omit<ComponentProps<typeof CalendarController>, keyof IControlledMutator<unknown>>
> = props =>
  CachedStateProvider<ICalendarPrerequisitesRecord, ComponentProps<typeof CalendarController>>({
    ...props,
    Component: CalendarController,
    localStoreKey: LocalStorageConfigs.calendarPrerequisitesMet.key
  });

/** A fully provisioned {@link CalendarController}, except for its `children`. */
const AppContextCalendarController = AppContextValueProvider<
  Pick<ICalendarControllerProps, "patient" | "calendarPrerequisiteSteps">,
  ComponentProps<typeof CachedCalendarController>
>({
  Component: CachedCalendarController,
  map: ({ patient }) => ({
    patient: patient,
    calendarPrerequisiteSteps: defaultCalendarPrerequisiteSteps
  })
});

export default AppContextCalendarController;
